import { createSelector, createEntityAdapter } from "@reduxjs/toolkit";
import { apiSlice } from "../../../app/api/apiSlice"

const tipUgovoraAdapter = createEntityAdapter({})

const initialState = tipUgovoraAdapter.getInitialState()

export const tipUgovoraApiSlice = apiSlice.injectEndpoints({
    endpoints: builder => ({
        getTipUgovora: builder.query({
            query: () => ({
                url: '/tipUgovora',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError;
                },
            }),
            transformResponse: responseData => {
                const loadedTipUgovora = responseData.map(tipUgovora => {
                    tipUgovora.id = tipUgovora._id;
                    return tipUgovora;
                });
                return tipUgovoraAdapter.setAll(initialState, loadedTipUgovora);
            },
            providesTags: (result, error, arg) => {
                if (result?.ids) {
                    return [
                        { type: 'TipUgovora', id: 'LIST' },
                        ...result.ids.map(id => ({ type: 'TipUgovora', id }))
                    ];
                } else {
                    return [{ type: 'TipUgovora', id: 'LIST' }];
                }
            }
        }),
        getTipUgovoraNames: builder.query({
            query: () => ({
                url: '/tipUgovora/names',
                validateStatus: (response, result) => {
                    return response.status === 200 && !result.isError
                },
            }),
        }),
        addNewTipUgovora: builder.mutation({
            query: initialUserData => ({
                url: '/tipUgovora',
                method: 'POST',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: [
                { type: 'TipUgovora', id: "LIST" }
            ]
        }),
        updateTipUgovora: builder.mutation({
            query: initialUserData => ({
                url: '/tipUgovora',
                method: 'PATCH',
                body: {
                    ...initialUserData,
                }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'TipUgovora', id: arg.id }
            ]
        }),
        deleteTipUgovora: builder.mutation({
            query: ({ id }) => ({
                url: `/tipUgovora`,
                method: 'DELETE',
                body: { id }
            }),
            invalidatesTags: (result, error, arg) => [
                { type: 'TipUgovora', id: arg.id }
            ]
        }),
    }),
})

export const {
    useGetTipUgovoraQuery,
    useGetTipUgovoraNamesQuery,
    useAddNewTipUgovoraMutation,
    useUpdateTipUgovoraMutation,
    useDeleteTipUgovoraMutation
} = tipUgovoraApiSlice



// // returns the query result object
// export const selectTipOrganizacijeResult = tipUgovoraApiSlice.endpoints.getTipOrganizacije.select()

// // creates memoized selector
// const selectTipOrganizacijeData = createSelector(
//     selectTipOrganizacijeResult,
//     TipOrganizacijeResult => TipOrganizacijeResult.data // normalized state object with ids & entities
// )

// //getSelectors creates these selectors and we rename them with aliases using destructuring
// export const {
//     selectAll: selectAllTipOrganizacije,
//     selectById: selectTipOrganizacijeById,
//     selectIds: selectTipOrganizacijeIds
//     // Pass in a selector that returns the users slice of state
// } = tipUgovoraAdapter.getSelectors(state => selectTipOrganizacijeData(state) ?? initialState)